/********************************************
 * Background Transitions
 ********************************************/

function fnBgTransitions() {

// Run
    fnApplyClass();

// Re-run on-scroll
    $(window).scroll(function () {
        fnApplyClass();
    });

// Re-run on-resize
    $(window).resize(function () {
        fnApplyClass();
    });

    function fnApplyClass(oElement, event) {

        //	If viewed 250px of height
        if ($(window).width() >= 1229) {
            var $oEl = $('body.home section.dark-bg, body.home footer.dark-bg');
            var iOffset = 500;
            if ($oEl.is(':in-viewport( ' + iOffset + ' )')) {
                $('body').addClass('dark-bg');
                $oEl.addClass('partly-viewed');
            } else {
                $('body').removeClass('dark-bg');
                $oEl.removeClass('partly-viewed');
            }
        }
    }

}

